import styled from 'styled-components'

const BodyText = styled.span`
  font-size: 16px;
  font-style: normal;
  line-height: 22px;
`

export default BodyText
